import { apiClient } from '../http'

export const adminService = {
    async checkAdmin() {
        const response = await apiClient.get('/admin/check')
        return response.data
    },

    async getStats() {
        const response = await apiClient.get('/admin/stats')
        return response.data
    },

    async getCases() {
        const response = await apiClient.get('/admin/cases')
        return response.data
    },

    async createCase(data) {
        const response = await apiClient.post('/admin/cases', data)
        return response.data
    },

    async updateCase(caseId, data) {
        const response = await apiClient.put(`/admin/cases/${caseId}`, data)
        return response.data
    },

    async addPromoCode(caseId, code, game) {
        const response = await apiClient.post(`/admin/cases/${caseId}/promo`, {
            code,
            game: game || 'STANDOFF_2',
        })
        return response.data
    },

    async addPromoCodesBulk(caseId, codes, game) {
        const response = await apiClient.post(
            `/admin/cases/${caseId}/promo/bulk`,
            { codes, game: game || 'STANDOFF_2' }
        )
        return response.data
    },

    async getCaseAnalytics(caseId) {
        const response = await apiClient.get(`/admin/cases/${caseId}/analytics`)
        return response.data
    },

    async getCasePromoCodes(caseId) {
        const response = await apiClient.get(
            `/admin/cases/${caseId}/promo-codes`
        )
        return response.data
    },

    async getCasePurchaseHistory(params) {
        const response = await apiClient.get('/admin/cases/purchase-history', {
            params,
        })
        return response.data
    },

    async getAdventRewards() {
        const response = await apiClient.get('/admin/advent/rewards')
        return response.data
    },

    async createAdventReward(data) {
        const response = await apiClient.post('/admin/advent/rewards', data)
        return response.data
    },

    async updateAdventReward(rewardId, data) {
        const response = await apiClient.put(
            `/admin/advent/rewards/${rewardId}`,
            data
        )
        return response.data
    },

    async deleteAdventReward(rewardId) {
        const response = await apiClient.delete(
            `/admin/advent/rewards/${rewardId}`
        )
        return response.data
    },

    async getAdventClaims(day) {
        const response = await apiClient.get('/admin/advent/claims', {
            params: { day },
        })
        return response.data
    },

    async exportAdventClaims() {
        const response = await apiClient.get('/admin/advent/export')
        return response.data
    },

    async createAdventRewardsBulk(data) {
        const response = await apiClient.post(
            '/admin/advent/rewards/bulk',
            data
        )
        return response.data
    },

    async addAdventPromoCodesBulk(rewardId, codes) {
        const response = await apiClient.post(
            `/admin/advent/rewards/${rewardId}/promo/bulk`,
            { codes }
        )
        return response.data
    },

    async getUsers(params) {
        const response = await apiClient.get('/admin/users', { params })
        return response.data
    },

    async updateReferralDisplayName(userId, displayName) {
        const response = await apiClient.post(
            `/admin/users/${userId}/referral-name`,
            { displayName }
        )
        return response.data
    },

    async getUserDetails(userId) {
        const response = await apiClient.get(`/admin/users/${userId}`)
        return response.data
    },

    async updateUserBalance(userId, amount, reason) {
        const response = await apiClient.post(
            `/admin/users/${userId}/balance`,
            { amount, reason }
        )
        return response.data
    },

    async updateUserSiteId(userId, siteId) {
        const response = await apiClient.post(`/admin/users/${userId}/siteid`, {
            siteId,
        })
        return response.data
    },

    async getUserTransactions(userId, params) {
        const response = await apiClient.get(
            `/admin/users/${userId}/transactions`,
            { params }
        )
        return response.data
    },

    async getUserTasks(userId) {
        const response = await apiClient.get(`/admin/users/${userId}/tasks`)
        return response.data
    },

    async resetUserTask(userId, taskId) {
        const response = await apiClient.delete(
            `/admin/users/${userId}/tasks/${taskId}`
        )
        return response.data
    },

    async getTasks() {
        const response = await apiClient.get('/admin/tasks')
        return response.data
    },

    async createTask(data) {
        const response = await apiClient.post('/admin/tasks', data)
        return response.data
    },

    async updateTask(taskId, data) {
        const response = await apiClient.put(`/admin/tasks/${taskId}`, data)
        return response.data
    },

    async deleteTask(taskId) {
        const response = await apiClient.delete(`/admin/tasks/${taskId}`)
        return response.data
    },

    async getTaskImages() {
        const response = await apiClient.get('/admin/tasks/images')
        return response.data
    },

    async uploadTaskImage(data) {
        const response = await apiClient.post('/admin/tasks/images', data)
        return response.data
    },

    async getTaskCasesList() {
        const response = await apiClient.get('/admin/tasks/cases-list')
        return response.data
    },

    async verifyBotInChannel(channelId) {
        const response = await apiClient.post('/admin/tasks/verify-channel', {
            channelId,
        })
        return response.data
    },

    async getReferralStats(params) {
        const response = await apiClient.get('/admin/referrals/stats', {
            params,
        })
        return response.data
    },

    async getMilestones() {
        const response = await apiClient.get('/admin/referrals/milestones')
        return response.data
    },

    async createMilestone(data) {
        const response = await apiClient.post(
            '/admin/referrals/milestones',
            data
        )
        return response.data
    },

    async updateMilestone(milestoneId, data) {
        const response = await apiClient.put(
            `/admin/referrals/milestones/${milestoneId}`,
            data
        )
        return response.data
    },

    async deleteMilestone(milestoneId) {
        const response = await apiClient.delete(
            `/admin/referrals/milestones/${milestoneId}`
        )
        return response.data
    },

    async getUserReferrals(userId, params) {
        const response = await apiClient.get(`/admin/referrals/users/${userId}`, { params })
        return response.data
    },

    async getUserReferralHistory(userId, params) {
        const response = await apiClient.get(
            `/admin/referrals/users/${userId}/history`,
            { params }
        )
        return response.data
    },

    async banUser(userId, reason) {
        const response = await apiClient.post(`/admin/users/${userId}/ban`, {
            reason,
        })
        return response.data
    },

    async unbanUser(userId) {
        const response = await apiClient.post(`/admin/users/${userId}/unban`)
        return response.data
    },

    async getMarketingCampaigns() {
        const response = await apiClient.get('/admin/marketing')
        return response.data
    },

    async createMarketingCampaign(data) {
        const response = await apiClient.post('/admin/marketing', data)
        return response.data
    },

    async updateMarketingCampaign(campaignId, data) {
        const response = await apiClient.put(
            `/admin/marketing/${campaignId}`,
            data
        )
        return response.data
    },

    async deleteMarketingCampaign(campaignId) {
        const response = await apiClient.delete(
            `/admin/marketing/${campaignId}`
        )
        return response.data
    },

    async sendMarketingCampaign(campaignId) {
        const response = await apiClient.post(
            `/admin/marketing/${campaignId}/send`
        )
        return response.data
    },

    async getMarketingCampaignStats(campaignId) {
        const response = await apiClient.get(
            `/admin/marketing/${campaignId}/stats`
        )
        return response.data
    },

    async getMarketingCasesList() {
        const response = await apiClient.get('/admin/marketing/cases-list')
        return response.data
    },

    async getCasesList() {
        const response = await apiClient.get('/admin/marketing/cases-list')
        return response.data
    },

    async getMarketingUsersCount() {
        const response = await apiClient.get('/admin/marketing/users-count')
        return response.data
    },

    async toggleMarketingCampaign(campaignId) {
        const response = await apiClient.post(
            `/admin/marketing/${campaignId}/toggle`
        )
        return response.data
    },

    async duplicateAdventDay(fromDay, toDay) {
        const response = await apiClient.post('/admin/advent/duplicate-day', {
            fromDay,
            toDay,
        })
        return response.data
    },

    async deleteAdventDay(day) {
        const response = await apiClient.delete(`/admin/advent/day/${day}`)
        return response.data
    },

    async getPromoCodeStatus(promoCode) {
        const response = await apiClient.get(`/admin/advent/promo/${promoCode}`)
        return response.data
    },

    async getAdventDayStats() {
        const response = await apiClient.get('/admin/advent/day-stats')
        return response.data
    },

    async detectBotReferrals(userId) {
        const response = await apiClient.get(
            `/admin/users/${userId}/detect-bots`
        )
        return response.data
    },

    async revokeUndeservedRewards(userId) {
        const response = await apiClient.post(
            `/admin/users/${userId}/revoke-rewards`
        )
        return response.data
    },

    async getMinesConfig() {
        const response = await apiClient.get('/admin/mines/config')
        return response.data
    },

    async updateMinesConfig(data) {
        const response = await apiClient.put('/admin/mines/config', data)
        return response.data
    },

    async getMinesStats() {
        const response = await apiClient.get('/admin/mines/stats')
        return response.data
    },

    async getMinesTopPlayers(period, page = 1, limit = 50) {
        const response = await apiClient.get('/admin/mines/top-players', { params: { period, page, limit } })
        return response.data
    },

    async getMinesGames(params) {
        const response = await apiClient.get('/admin/mines/games', { params })
        return response.data
    },

    async getBattlesConfig() {
        const response = await apiClient.get('/admin/battles/config')
        return response.data
    },

    async updateBattlesConfig(data) {
        const response = await apiClient.put('/admin/battles/config', data)
        return response.data
    },

    async getBattlesStats() {
        const response = await apiClient.get('/admin/battles/stats')
        return response.data
    },

    async getBattlesTopPlayers(period, page = 1, limit = 50) {
        const response = await apiClient.get('/admin/battles/top-players', { params: { period, page, limit } })
        return response.data
    },

    async getBattlesGames(params) {
        const response = await apiClient.get('/admin/battles/games', { params })
        return response.data
    },

    async getBattlesBots() {
        const response = await apiClient.get('/admin/battles/bots')
        return response.data
    },

    async getBattlesAbuse(period) {
        const response = await apiClient.get('/admin/battles/abuse', { params: { period } })
        return response.data
    },

    // Triggers
    async getTriggerSettings() {
        const response = await apiClient.get('/admin/triggers/settings')
        return response.data
    },

    async updateTriggerSettings(data) {
        const response = await apiClient.put('/admin/triggers/settings', data)
        return response.data
    },

    async getTriggerConfigs() {
        const response = await apiClient.get('/admin/triggers/configs')
        return response.data
    },

    async getTriggerConfig(configId) {
        const response = await apiClient.get(`/admin/triggers/configs/${configId}`)
        return response.data
    },

    async updateTriggerConfig(configId, data) {
        const response = await apiClient.put(`/admin/triggers/configs/${configId}`, data)
        return response.data
    },

    async createTriggerMessage(configId, data) {
        const response = await apiClient.post(`/admin/triggers/configs/${configId}/messages`, data)
        return response.data
    },

    async updateTriggerMessage(messageId, data) {
        const response = await apiClient.put(`/admin/triggers/messages/${messageId}`, data)
        return response.data
    },

    async deleteTriggerMessage(messageId) {
        const response = await apiClient.delete(`/admin/triggers/messages/${messageId}`)
        return response.data
    },

    async getTriggerStats() {
        const response = await apiClient.get('/admin/triggers/stats')
        return response.data
    },

    async testTrigger(configId) {
        const response = await apiClient.post(`/admin/triggers/configs/${configId}/test`)
        return response.data
    },

    async getLeaderboardSettings() {
        const response = await apiClient.get('/admin/leaderboard/settings')
        return response.data
    },

    async updateLeaderboardSettings(data) {
        const response = await apiClient.put('/admin/leaderboard/settings', data)
        return response.data
    },

    async getLeaderboardRewards(type) {
        const params = type ? { type } : {}
        const response = await apiClient.get('/admin/leaderboard/rewards', { params })
        return response.data
    },

    async updateLeaderboardRewards(rewards) {
        const response = await apiClient.put('/admin/leaderboard/rewards', { rewards })
        return response.data
    },

    async addLeaderboardPromoCodes(position, type, codes) {
        const response = await apiClient.post(`/admin/leaderboard/rewards/${position}/promo-codes`, { type, codes })
        return response.data
    },

    async getLeaderboardCurrent() {
        const response = await apiClient.get('/admin/leaderboard/current')
        return response.data
    },

    async getLeaderboardHistory() {
        const response = await apiClient.get('/admin/leaderboard/history')
        return response.data
    },

    async finalizeLeaderboard() {
        const response = await apiClient.post('/admin/leaderboard/finalize')
        return response.data
    },
}
